"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../axios-client/axios-client.service");
var payment_media_const_1 = require("./payment-media.const");
/**
 * PaymentMediaService
 * @class
 */
var PaymentMediaService = /** @class */ (function () {
    function PaymentMediaService() {
    }
    /**
     * Get the media object
     * @param mediaUuid {string},
     * @returns {Promise<PaymentMediaResponse>}
     */
    PaymentMediaService.prototype.getMedia = function (mediaUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = payment_media_const_1.PAYMENT_MEDIA_ENDPOINT.getMedia
            .replace('{{version}}', version)
            .replace('{{mediaUuid}}', mediaUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    return PaymentMediaService;
}());
/**
 * PaymentMethodsService Class Instance
 * @namespace
 */
exports.paymentMedia = new PaymentMediaService();
